import {useEffect, useState} from "react";
import ICON_MAPPING from "../images/location-icon-mapping";
import ICON_ATLAS from "../images/location-icon-atlas.png";


const useIconDict = () => {
  const [iconDict, setIconDict] = useState({});

  useEffect(() => {
    const canvas = document.createElement('canvas');
    const samplingCanvas = document.createElement('canvas');

    document.body.appendChild(canvas);
    document.body.appendChild(samplingCanvas);

    const canvasWidth = Math.max(...Object.values(ICON_MAPPING).map(({ x, width }) => x + width));
    const canvasHeight = Math.max(...Object.values(ICON_MAPPING).map(({ y, height }) => y + height));

    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    const ctx = canvas.getContext('2d');
    const img = new Image();

    img.onload = () => {
      ctx.drawImage(img, 0, 0);

      setIconDict(
        Object.entries(ICON_MAPPING).reduce((acc, [iconCode, {x, y, width, height, anchorX, anchorY}]) => {
          const imageData = ctx.getImageData(x, y, width, height);
          samplingCanvas.width = width;
          samplingCanvas.height = height;
          samplingCanvas.getContext('2d').putImageData(imageData, 0, 0);
          const data = samplingCanvas.toDataURL();
          acc[iconCode] = { x, y, width, height, data, anchorX, anchorY };
          return acc;
        }, {})
      );

      canvas.parentElement.removeChild(canvas);
      samplingCanvas.parentElement.removeChild(samplingCanvas);
    };

    img.src = ICON_ATLAS;
  }, []);

  return iconDict;
};


export default useIconDict;
